/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchRequestModel } from '../../models/search-request-model';
import { UserModelSearchResultModel } from '../../models/user-model-search-result-model';

export interface UserSearchUserPost$Plain$Params {
      body?: SearchRequestModel
}

export function userSearchUserPost$Plain(http: HttpClient, rootUrl: string, params?: UserSearchUserPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<UserModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, userSearchUserPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<UserModelSearchResultModel>;
    })
  );
}

userSearchUserPost$Plain.PATH = '/User/SearchUser';
